import { ParentComponent } from "solid-js";

const FormRow: ParentComponent = (props) => (
  <div class="row mt-3 me-4">{props.children}</div>
);
export default FormRow;
